module.exports = __webpack_public_path__ + "static/img/title-button2.8b7ee6c6.png";